<template>
  <div class="pxdiv">
    <div class="htmldiv">
      <div class="st fs28 fbold tcenter pt30 mb40">
        <div class="stborder dinline-block prelative wd80">
          <div class="tt wd100 pabsolute">
            <div class="dinline-block fbold">
              <span class="tc11">培训</span>与技能考证
            </div>
          </div>
        </div>
      </div>
      <div class="cont fs0 pb20 tcenter tcenter">
        <TrainItem v-for="(item,index) in train" v-if="index<3" :key="index" :index="index" :item="item"/>
      </div>
    </div>
  </div>
</template>

<script>
import TrainItem from './train-item.vue'
export default {
  name: "train",
  props: [
    'train',
  ],
  components: {
    TrainItem,
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index/train.vue